module.exports = __webpack_public_path__ + "main/assets/public/button/down-arrow.75489669b1783330.svg";